import api from '@/libs/api'
import store from '@/store'

const getProjectId = () => store.state.app.projectId

export default {
  namespaced: true,
  state: {
    jobTemplates: [],
    fetchingJobTemplates: true,
    jobTemplate: null,
    fetchingJobTemplate: false,
    emptyJobTemplate: null,
    fetchingEmptyJobTemplate: false,
    outputGroupOptions: [],
    fetchingOutputGroupOptions: false,
    creatingJobTemplate: false,
    editingJobTemplate: false,
    deletingJobTemplate: false,
    fetchingJobTemplateFilters: false,
    jobTemplateFilters: null,
    duplicatingJobTemplate: false,
    jobTemplatesResultInfo: {},
    currentPage: 1,
    creatingOutputPreset: false,
    outputTabs: [],
  },
  getters: {
    jobTemplates: state => state.jobTemplates,
    jobTemplate: state => state.jobTemplate,
    fetchingjobTemplate: state => state.fetchingjobTemplate,
    currentPage: state => state.currentPage,
  },
  mutations: {
    SET_JOB_TEMPLATES(state, res) {
      state.jobTemplates = res.result
      state.jobTemplatesResultInfo = res.resultInfo
    },
    SET_FETCHING_JOB_TEMPLATES(state, value) {
      state.fetchingJobTemplates = value
    },
    SET_JOB_TEMPLATE(state, value) {
      state.jobTemplate = value
    },
    SET_FETCHING_JOB_TEMPLATE(state, value) {
      state.fetchingJobTemplate = value
    },
    SET_EMPTY_JOB_TEMPLATE(state, value) {
      state.emptyJobTemplate = value
    },
    SET_FETCHING_EMPTY_JOB_TEMPLATE(state, value) {
      state.fetchingEmptyJobTemplate = value
    },
    SET_FETCHING_OUTPUT_GROUP_OPTIONS(state, value) {
      state.fetchingOutputGroupOptions = value
    },
    SET_OUTPUT_GROUP_OPTIONS(state, value) {
      state.outputGroupOptions = value
    },
    SET_CREATING_JOB_TEMPLATE(state, value) {
      state.creatingJobTemplate = value
    },
    SET_DELETING_JOB_TEMPLATE(state, value) {
      state.deletingJobTemplate = value
    },
    SET_DUPLICATING_JOB_TEMPLATE(state, value) {
      state.duplicatingJobTemplate = value
    },
    SET_EDITING_JOB_TEMPLATE(state, value) {
      state.editingJobTemplate = value
    },
    SET_FETCHING_JOB_TEMPLATE_FILTERS(state, value) {
      state.fetchingJobTemplateFilters = value
    },
    SET_JOB_TEMPLATE_FILTERS(state, value) {
      state.jobTemplateFilters = value
    },
    REMOVE_JOB_TEMPLATE(state, id) {
      state.jobTemplates = state.jobTemplates.filter(j => j.id !== id)
    },
    SET_CURRENT_PAGE(state, value) {
      state.currentPage = value
    },
    SET_CREATING_OUTPUT_PRESET(state, value) {
      state.creatingOutputPreset = value
    },
    SET_OUTPUT_TABS(state, value) {
      state.outputTabs = value
    },
  },
  actions: {
    fetchJobTemplates({ commit }, payload) {
      const page = `pageIndex=${payload.page || 0}`
      const type = `type=${payload.type}`
      const category = `${payload.category ? `&category=${payload.category}` : ''}`
      const search = `${payload.search ? `&search=${payload.search}` : ''}`
      let query = `?pageSize=10&${page}&${type}${category}${search}`
      if (payload.liveEncoder) {
        query += '&liveEncoder=1'
      }

      commit('SET_FETCHING_JOB_TEMPLATES', true)
      return new Promise((resolve, reject) => {
        api('encoder').get(`projects/${getProjectId()}/jobtemplates${query}`)
          .then(response => {
            commit('SET_JOB_TEMPLATES', response.data)
            resolve(response)
          })
          .catch(error => { reject(error) })
          .finally(() => { commit('SET_FETCHING_JOB_TEMPLATES', false) })
      })
    },
    fetchJobTemplateById({ commit }, id) {
      commit('SET_FETCHING_JOB_TEMPLATE', true)
      return new Promise((resolve, reject) => {
        api('encoder').get(`projects/${getProjectId()}/jobtemplates/${id}`)
          .then(response => {
            commit('SET_JOB_TEMPLATE', response.data)
            resolve(response)
          })
          .catch(error => { reject(error) })
          .finally(() => { commit('SET_FETCHING_JOB_TEMPLATE', false) })
      })
    },
    fetchEmptyJobTemplate({ commit }) {
      commit('SET_FETCHING_EMPTY_JOB_TEMPLATE', true)
      return new Promise((resolve, reject) => {
        api('encoder').get(`projects/${getProjectId()}/jobtemplates/0`)
          .then(response => {
            commit('SET_EMPTY_JOB_TEMPLATE', response.data)
            resolve(response)
          })
          .catch(error => { reject(error) })
          .finally(() => { commit('SET_FETCHING_EMPTY_JOB_TEMPLATE', false) })
      })
    },
    fetchOutputGroupOptions({ commit }) {
      commit('SET_FETCHING_OUTPUT_GROUP_OPTIONS', true)
      return new Promise((resolve, reject) => {
        api('encoder').get(`projects/${getProjectId()}/outputgroups`)
          .then(response => {
            commit('SET_OUTPUT_GROUP_OPTIONS', response.data)
            resolve(response)
          })
          .catch(error => { reject(error) })
          .finally(() => { commit('SET_FETCHING_OUTPUT_GROUP_OPTIONS', false) })
      })
    },
    // eslint-disable-next-line no-empty-pattern
    fetchOutputGroupSettings({ }, id) {
      return api('encoder').get(`projects/${getProjectId()}/outputgroups/${id}`)
    },
    createJobTemplate({ commit }, template) {
      commit('SET_CREATING_JOB_TEMPLATE', true)
      return new Promise((resolve, reject) => {
        api('encoder').post(`projects/${getProjectId()}/jobtemplates`, template)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_CREATING_JOB_TEMPLATE', false) })
      })
    },
    editJobTemplate({ commit }, template) {
      commit('SET_EDITING_JOB_TEMPLATE', true)
      return new Promise((resolve, reject) => {
        api('encoder').put(`projects/${getProjectId()}/jobtemplates`, template)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_EDITING_JOB_TEMPLATE', false) })
      })
    },
    deleteJobTemplate({ commit }, id) {
      commit('SET_DELETING_JOB_TEMPLATE', true)
      return new Promise((resolve, reject) => {
        api('encoder').delete(`projects/${getProjectId()}/jobtemplates/${id}`)
          .then(response => {
            commit('REMOVE_JOB_TEMPLATE', id)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_DELETING_JOB_TEMPLATE', false) })
      })
    },
    duplicateJobTemplate({ commit }, id) {
      commit('SET_DUPLICATING_JOB_TEMPLATE', true)
      return new Promise((resolve, reject) => {
        api('encoder').post(`projects/${getProjectId()}/jobtemplates/${id}/duplicate`)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_DUPLICATING_JOB_TEMPLATE', false) })
      })
    },
    fetchJobTemplateFilters({ commit }, id) {
      const ext = id === 0 || id === 1 ? `?requestType=${id}` : ''
      commit('SET_FETCHING_JOB_TEMPLATE_FILTERS', true)
      return new Promise((resolve, reject) => {
        api('encoder').get(`projects/${getProjectId()}/jobtemplates/filters${ext}`)
          .then(response => {
            commit('SET_JOB_TEMPLATE_FILTERS', response.data)
            resolve(response)
          })
          .catch(error => { reject(error) })
          .finally(() => { commit('SET_FETCHING_JOB_TEMPLATE_FILTERS', false) })
      })
    },
  },
}
